<template>
    <v-dialog  v-model="dialog" scrollable max-height="auto" :max-width="($vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm') ? '90%' : '50%'" persistent >
        <v-card 
                outlined
                height="75vh"
                prominent
                class="mx-auto elevation-0 overflow-y-auto"
                :loading='loading'
            >

            <v-card-title class="ma-0 pa-0">
                <v-app-bar dense height="45" class='mb-4 elevation-1'>
                        <v-toolbar-title class="subtitle-1">
                            Filtros
                        </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon @click.native="clearFilter()" v-bind="attrs" v-on="on">
                                <v-icon color="primary lighten-2">mdi-filter-remove-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Limpar Filtro</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon @click.native="dialog = false" v-bind="attrs" v-on="on">
                                <v-icon color="red lighten-2">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Fechar</span>
                    </v-tooltip>
                </v-app-bar>
            </v-card-title>
            
            <v-card-text  class="pt-2">
                <v-container>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <sys-select-campus
                                :model.sync="campus_id"
                                label="Campus*"
                                auto-complete
                                filterRelation="ambiences"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <sys-select-block
                                :model.sync="blocks"
                                label="Bloco"
                                multiple
                                selectAll
                                :campus-id="campus_id"
                                :disabled="campus_id == null"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="12">
                        <sys-select-ambience-type
                            :model.sync="types"
                            label="Tipo de Ambiente"
                            multiple
                            selectAll
                            :campus-id="campus_id"
                            :disabled="campus_id == null"
                        />
                      </v-col>
                  </v-row>
                </v-container>
            </v-card-text>

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn 
                    color='success' 
                    @click.prevent.stop="filter()"
                    :disabled="disableButton"
                >
                    Filtrar
                    <v-icon right dark>mdi-filter-menu-outline</v-icon>
                </v-btn>
            </v-card-actions>
            
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: "SysAmbienceFilter",
    data: (vm) => ({
        dialog: false,
        loading: false,
        campus_id: null,
        blocks: [],
        types: [],
    }),
    mounted() {
        
    },
    computed: {

        disableButton (){
            
            return !this.campus_id;

        },

    },
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },

    watch: {

        dialog() {
            this.$emit('update:show', this.dialog);
        },

        show(val) {
            
            this.dialog = val;

            if(val){
                this.updating = false;
            }
        },

    },
    methods: {

       filter(){

            var payload = {};
        
            if(this.campus_id){
                
                payload.find_columns = 
                    {
                        campus_id:   this.campus_id,
                    };
                
            }

            if(this.blocks && this.blocks.length > 0){
                
                let ids = this.blocks.map(o => o['id']).join(',');

                if(!payload.filter_relations){
                    payload.filter_relations = [];
                }
                
                payload.filter_relations.push({
                        name:   'block',
                        key:    'id', 
                        value:  ids,
                        clause: 'whereIn'
                    }
                );
            }

            if(this.types && this.types.length > 0){
                
                let ids = this.types.map(o => o['id']).join(',');

                if(!payload.filter_relations){
                    payload.filter_relations = [];
                }
                
                payload.filter_relations.push({
                        name:   'type',
                        key:    'id', 
                        value:  ids,
                        clause: 'whereIn'
                    }
                );
            }

            this.$emit('filter', payload);

       },

       clearFilter(){

            this.campus_id = null;
            this.blocks = [];
            this.types = [];
            
            this.$emit('filter', null);

       },

    }
}
</script>